export const BlazeDoc = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 36 43" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_2718_39810)">
        <rect
          x="6.95001"
          y="7.47461"
          width="22.3186"
          height="28.6954"
          rx="1.28823"
          fill="white"
          shapeRendering="crispEdges"
        />
        <rect x="9.07581" y="25.5391" width="18.0674" height="1.45648" rx="0.728239" fill="#58AFFE" />
        <rect x="9.07581" y="28.6553" width="18.0674" height="1.45648" rx="0.728239" fill="#58AFFE" />
        <rect x="9.07581" y="31.7725" width="12.7867" height="1.45648" rx="0.728238" fill="#58AFFE" />
        <rect x="9.07581" y="22.4229" width="12.7867" height="1.45648" rx="0.728239" fill="#58AFFE" />
        <g clipPath="url(#clip0_2718_39810)">
          <path d="M27.3493 9.3623V20.061H8.86969L27.3493 9.3623Z" fill="url(#paint0_linear_2718_39810)" />
          <path d="M8.86966 20.0605V9.36184H27.3492L8.86966 20.0605Z" fill="url(#paint1_linear_2718_39810)" />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_2718_39810"
          x="0.454157"
          y="0.978755"
          width="35.3103"
          height="41.687"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3.24793" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2718_39810" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2718_39810" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_2718_39810"
          x1="18.5715"
          y1="13.3986"
          x2="20.0704"
          y2="20.9306"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6D00" />
          <stop offset="1" stopColor="#F8EF6F" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2718_39810"
          x1="8.86966"
          y1="12.304"
          x2="17.3892"
          y2="17.0667"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#47FF65" />
          <stop offset="1" stopColor="#2C99FF" />
        </linearGradient>
        <clipPath id="clip0_2718_39810">
          <rect x="8.86969" y="9.3623" width="18.4796" height="10.6987" rx="1.17892" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
